import React, { useState } from "react";
import { PortfolioElementType } from "types/PortfolioTypes";
import styles from "./portfolioCompareTableDelta.module.scss";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import PortfolioTableCompare from "./PortfolioTableCompare";
import PortfolioDelta from "./PortfolioDelta";
// import FinecoTable from "./components/FinecoTable";
type Props = {
  dataItem: PortfolioElementType;
  dataItem2: PortfolioElementType;
  titleDelta: string;
  subSection?: boolean;
  hideTotal?: boolean;
};
const PortfolioCompareTableDelta: React.FC<Props> = ({
  dataItem,
  dataItem2,
  subSection,
  titleDelta,
  hideTotal = false,
}) => {
  const [tableHeight, setTableHeight] = useState(0);
  return (
    <>
      {!subSection && (
        <h3 className={commonStyles.titleChart}>{dataItem.configData.label}</h3>
      )}
      {subSection && (
        <div className={commonStyles.subtitleChart}>
          {dataItem.configData.label}
        </div>
      )}
      <div
        className={[
          styles.portfolioDistribution,
          styles.twoChartSideBySide,
          "printRow",
        ].join(" ")}
      >
        <PortfolioTableCompare
          dataItem={dataItem}
          dataItem2={dataItem2}
          hideTotal={hideTotal}
          onResize={setTableHeight}
        />
        <PortfolioDelta
          title={titleDelta}
          dataItem={dataItem}
          dataItem2={dataItem2}
          tableHeight={tableHeight}
        />
      </div>
    </>
  );
};

export default PortfolioCompareTableDelta;
